var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    stroke: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM12 3.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm-1.261 11c-1.614 0-2.947.342-3.874 1.19-.937.858-1.365 2.142-1.365 3.81v.5h1v-.5c0-1.507.385-2.472 1.04-3.072.664-.607 1.701-.928 3.199-.928h2.54c1.487 0 2.52.32 3.183.928.653.6 1.038 1.565 1.038 3.072v.5h1v-.5c0-1.668-.428-2.952-1.362-3.809-.926-.849-2.254-1.191-3.86-1.191h-2.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.53831f23ec7585cc7ed9dc2c594ff7c8.svg";
export { ForwardRef as ReactComponent };